/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerfollowname3Inputs */

const en_placeflyerfollowname3 = /** @type {(inputs: Placeflyerfollowname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow us`)
};

const de_placeflyerfollowname3 = /** @type {(inputs: Placeflyerfollowname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folg uns`)
};

/**
* | output |
* | --- |
* | "Follow us" |
*
* @param {Placeflyerfollowname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerfollowname3 = /** @type {((inputs?: Placeflyerfollowname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerfollowname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerfollowname3(inputs)
	return de_placeflyerfollowname3(inputs)
});
export { placeflyerfollowname3 as "placeFlyerFollowName" }